module.exports = __webpack_public_path__ + "fonts/iconfont.5614f06b.eot";